import type { ReduxApplicationState } from '../combinedReducer';

export const selectPartnerInsights = (state: ReduxApplicationState) => state.partner.insights;

export const selectPartnerContent = (state: ReduxApplicationState) => state.partner.content;
